import { app } from '../../../bootstrap/core';
import { TicketReader } from './model/TicketReader';
import { TicketDetailReader } from './model/TicketDetailReader';
import { LockedTicketReader } from './model/LockedTicketReader';
import _ from 'lodash';

const ticketReaderFactory = () => {
  'ngInject';

  const createFor = (ticket) => {
    return new TicketReader(ticket);
  };

  const createForDetail = (ticket) => {
    if (ticket instanceof LockedTicketReader) {
      return ticket;
    }
    return new TicketDetailReader(ticket);
  };

  // Create special locked ticket reader for locked ticket model
  const createForLocked = (ticket, lock) => {
    return new LockedTicketReader(ticket, lock);
  };

  return {
    createFor,
    createForDetail,
    createForLocked
  };
};

app.factory('ticketReaderFactory', ticketReaderFactory);
app.filter('ticketReader', (ticketReaderFactory) => {
  'ngInject';

  // Creates a function that memoizes the result of func which is used as the map cache key.
  // The func is invoked with the this binding of the memoized function.
  return _.memoize(function(items) {
    if (!items) {
      return items;
    }
    if (!angular.isArray(items)) {
      return ticketReaderFactory.createFor(items);
    }
    return _.map(items, i => {
      return ticketReaderFactory.createFor(i);
    });
  });
});
